import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import ClienteNaoCompareceu from "../ClienteNaoCompareceu";

interface IBotaoClienteNaoCompareceuProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
}

export default function BotaoClienteNaoCompareceu(
    props: IBotaoClienteNaoCompareceuProps
) {
    return (
        <button
            type="button"
            className="btn btn-primary d-flex align-items-center justify-content-center g-2 m-2"
            onClick={() => {
                props.setShow(true);
                props.setModal({
                    headerComponent: "Cliente Não Compareceu",
                    IconHeader: faUser,
                    Component: () => (
                        <ClienteNaoCompareceu setShow={props.setShow} />
                    ),
                    size: "lg",
                });
            }}
        >
            CLIENTE NÃO COMPARECEU
        </button>
    );
}
